import React, { useEffect, useState, Fragment } from 'react';

import { estados, paqueteriasRecolecciones } from "../constants/constants";

import TableRecolecciones from "../components/Tables/TableRecolecciones/TableRecolecciones";

import useRecoleccionAPI from "../hooks/useRecoleccionAPI";
import useRecoleccionesAPI from "../hooks/useRecoleccionesAPI";
import useGetDirecciones from "../hooks/direcciones/useGetDirecciones";
import Select from "react-select";
import MSelect from "../components/Select/Select";
import useStyles from "./styles/stylesRecolecciones";
import { ButtonGroup,Grid,
  Paper,
  TextField,
  Button,
  Typography,
  Snackbar,
  CircularProgress } from "@material-ui/core";
import SnackbarWrapper from "../components/SnackbarContentWrapper/SnackbarContentWrapper";
import useGetDestinatarios from "../hooks/destinatarios/useGetDestinatarios";
import Modal from "../components/Modal/ModalRecoleccion";

const findDestinatario = (_id = "", destinatarios = []) => {
  const r = destinatarios.find((el) => el._id === _id);
  return r ? r.nombre : "";
};

const Recolecciones = () => {
    const [currentTable, setCurrentTable] = useState("recolecciones");
    const [paqueteria,setPaqueteriasRecolecciones]=useState(null);
    const [paquetes,setPaquetes]=useState("");
    const [peso,setPeso]=useState("");
    const [showError, setShowError] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [horaInicial,setHoraInicial]=useState("9");
    const [horaFinal,setHoraFinal]=useState("18");
    const [fechaRecoleccion,setFechaRecoleccion]=useState("");

    const [nombreRemitente,setNombreRemitente]=useState("");
    const [emailRemitente,setEmailRemitente]=useState("");
    const [calleRemitente,setCalleRemitente]=useState("");
    const [numeroRemitente,setNumeroRemitente]=useState("");
    const [coloniaRemitente,setColoniaRemitente]=useState(""); 
    const [delegacionRemitente,setDelegacionRemitente]=useState("");
    const [estadoRemitente, setEstadoRemitente] = useState(null);
    
    const [cpRemitente,setCPRemitente]=useState("");    
    const [telefonoRemitente,setTelefonoRemitente]=useState("");
    const [referenciaRemitente,setReferenciaRemitente]=useState("");    
    const [showModal, setShowModal] = useState(false);
    const [Add, setAdd] = useState(false);
    const classes = useStyles();
    
    const [direccionRemitente, setDireccionRemitente] = useState("");

    const [{ data: destinatarios }] = useGetDestinatarios();

    const handleSelectDirRemitente = (id = "") => {
      setDireccionRemitente(id);
    };

    const [
      { data: direcciones},
      getDirecciones,
    ] = useGetDirecciones();

    const handleModalClose = () => {
      setShowModal(false);
    };

    const [{ data, isLoading }, doFetch] = useRecoleccionesAPI("");
    useEffect(() => {
      doFetch();
    }, [doFetch]);
    const handleAdd=()=>{
      setAdd(true); 
    }
    const [{isErrorRecoleccion,errorRecoleccion}, doRecoleccion] = useRecoleccionAPI({});
    const getNextWork=(d)=>{
      if(d.getHours()>=12){
        d.setDate(d.getDate()+1);
      if (d.getDay()===0) {
        if((d.getHours()+5)>24)d.setDate(d.getDate()+1);
      }
      else if (d.getDay()===6){
        if((d.getHours()+5)>24)d.setDate(d.getDate()+2);
      }   
    }
      return d.getUTCFullYear()+"-"+(d.getUTCMonth()+1<10?("0"+(d.getUTCMonth()+1)):d.getUTCMonth()+1)+"-"+(d.getDate()<10?("0"+(d.getDate())):d.getDate()); 
    }

    useEffect(() => {
      if (!direccionRemitente) return;
      //resetGenerar();
      //setShowCotizacion(false);
      const dir = direcciones.find((el) => direccionRemitente === el._id);
      console.log(dir);
      setEstadoRemitente(estados.find((el) => el.value === dir.estado));
      setCPRemitente(dir.cp);
      setCalleRemitente(dir.calle);
      setNumeroRemitente(dir.numero);
      setColoniaRemitente(dir.colonia);
      setDelegacionRemitente(dir.delegacion);
      setReferenciaRemitente(dir.referencia);
      // eslint-disable-next-line
    }, [direccionRemitente, direcciones]);

    useEffect(() => {
      getDirecciones("yes");
    }, [direcciones, getDirecciones]);

    const handleRecoleccion = async () => {
      if (!validateRecoleccion()) return;
      const dataRecoleccion = {
        origin:{
          name:nombreRemitente,
          company:nombreRemitente,
          email:emailRemitente,
          phone:telefonoRemitente,
          street: calleRemitente,
          number: numeroRemitente,
          district: coloniaRemitente,
          city: delegacionRemitente,
          state: estadoRemitente.value,
          country: "MX",
          postalCode: cpRemitente
       },
       shipment:{
          carrier:paqueteria.value,
          type: 1,
          pickup:{
             timeFrom:horaInicial,
             timeTo:horaFinal,
             date:fechaRecoleccion,
             instructions:referenciaRemitente,
             totalPackages:paquetes,
             totalWeight:peso
          },
          settings:{
             currency:"MXN",
             labelFormat:"pdf"
          }
       }
      }
      await doRecoleccion(dataRecoleccion);
      console.log(errorRecoleccion);
      setShowModal(true);
      //setRecoleccion(true);
      // console.log(data);
    };

    const validateRecoleccion = () => {
      const errores = [];
      if (!nombreRemitente) errores.push("nombre remitente");
      if (!emailRemitente) errores.push("correo del remitente");
      if (!calleRemitente) errores.push("calle del remitente");
      if (!numeroRemitente) errores.push("numero del remitente");
      if (!coloniaRemitente) errores.push("colonia del remitente");
      if (!delegacionRemitente) errores.push("delegación del remitente");
      if (!telefonoRemitente) errores.push("teléfono del remitente");
      if (!paqueteria) errores.push("opción de paquetería");
      if (!paquetes) errores.push("cantida de paquetes");
      if (!peso) errores.push("peso total de los paquetes");
      
      if (calleRemitente.length < 10)
        errores.push("las calles deben tener al menos 10 caracteres");

      if (errores.length > 0) {
        setErrorMessage(
          "Falta por rellenar / corregir los siguientes campos: " +
            errores.join(", ")
        );
        setShowError(true);
        return false;
      }
      return true;
    };  
    
    useEffect(() => {
      if(isErrorRecoleccion && errorRecoleccion!==""){
        setErrorMessage(
          errorRecoleccion 
        );
        setShowError(true);
      }
      
    }, [isErrorRecoleccion,errorRecoleccion]); 

    useEffect(() => {
      console.log(isLoading);
      setCurrentTable("recolecciones");
        if (!paqueteria) return;
        if(paqueteria.value==="fedex"){setHoraInicial(9);setHoraFinal(13)};
        if(paqueteria.value==="dhl"){setHoraInicial(10);setHoraFinal(14)};
        if(paqueteria.value==="redpack"){setHoraInicial(9);setHoraFinal(18)};
        if(paqueteria.value==="sendex"){setHoraInicial(9);setHoraFinal(18)};
        if(paqueteria.value==="carssa"){setHoraInicial(9);setHoraFinal(18)};
        if(paqueteria.value==="ups"){setHoraInicial(9);setHoraFinal(18)};
        setFechaRecoleccion(getNextWork(new Date()));
      }, [paqueteria]);  
    return (isLoading || Object.keys(data).length === 0?<CircularProgress/>:
      <div className={classes.root}>
          <ButtonGroup
            className={classes.buttonG}
            color="secondary"
            size="large"
            variant="contained"
          >
            <Button
              className={classes.botonRecolectar}
              color="primary"
              variant="contained"
              onClick={handleAdd}
            >
              Nueva Recolección
            </Button>
          </ButtonGroup>
          
      {Add?<Grid className={classes.root} container spacing={1}>
          <Grid item sm={12} md={6} >
          <Paper className={classes.paper} style={{margin:0}}>
              <Typography
                component="h1"
                variant="h6"
                className={classes.titulo}
              >
                1 - Origen:
                
              </Typography>
              <div className={classes.formCol}>
                <Grid container spacing={3}>
                <Grid item xs={12} sm={12} md={12}>
                  {direcciones.length === 0 ? (
                    <Fragment></Fragment>
                  ) : (
                    <MSelect
                      items={direcciones.map((el) => ({
                        ...el,
                        label:
                          findDestinatario(el.destinatario, destinatarios) +
                          `: ${el.calle} ${el.numero}`,
                      }))}
                      label="Mis direcciones"
                      selectHandler={handleSelectDirRemitente}
                    />
                  )}
                </Grid>
                  <Grid item sm={12} md={6}>
                  <TextField
                    variant="outlined"
                    label="Nombre*"
                    color="primary"
                    className={classes.formItem}
                    onChange={(e) =>
                      e
                        ? setNombreRemitente(e.target.value)
                        : setNombreRemitente("")
                    }
                  />
                </Grid>
                <Grid item sm={12} md={6}>
                  <TextField
                    variant="outlined"
                    label="Email*"
                    color="primary"
                    className={classes.formItem}
                    onChange={(e) =>
                      e
                        ? setEmailRemitente(e.target.value)
                        : setEmailRemitente("")
                    }
                  />
                </Grid>
                  <Grid item sm={12} md={6}>
                    <TextField
                      variant="outlined"
                      label="Calle*"
                      color="primary"
                      className={classes.formItem}
                      value={calleRemitente}
                      onChange={(e) =>
                        e
                          ? setCalleRemitente(e.target.value)
                          : setCalleRemitente("")
                      }
                    />
                  </Grid>
                  <Grid item sm={12} md={6}>
                    <TextField
                      variant="outlined"
                      label="Número*"
                      color="primary"
                      className={classes.formItem}
                      value={numeroRemitente}
                      onChange={(e) =>
                        e
                          ? setNumeroRemitente(e.target.value)
                          : setNumeroRemitente("")
                      }
                    />
                  </Grid>
                  <Grid item sm={12} md={6}>
                    <TextField
                      variant="outlined"
                      label="Colonia*"
                      color="primary"
                      className={classes.formItem}
                      value={coloniaRemitente}
                      onChange={(e) =>
                        e
                          ? setColoniaRemitente(e.target.value)
                          : setColoniaRemitente("")
                      }
                    />
                  </Grid>
                  <Grid item sm={12} md={6}>
                    <TextField
                      variant="outlined"
                      label="Delegación*"
                      color="primary"
                      className={classes.formItem}
                      value={delegacionRemitente}
                      onChange={(e) =>
                        e
                          ? setDelegacionRemitente(e.target.value)
                          : setDelegacionRemitente("")
                      }
                    />
                  </Grid>
                  <Grid item sm={12} md={6}>
                  <Select
                    className={classes.select}
                    options={estados}
                    placeholder="Estado*"
                    value={estadoRemitente}
                    onChange={
                      setEstadoRemitente
                    }
                  />
                  </Grid>
                  <Grid item sm={12} md={6}>
                    <TextField
                      variant="outlined"
                      label="Código Postal"
                      color="primary"
                      className={classes.formItem}
                      value={cpRemitente}
                      onChange={(e) =>
                        e
                          ? setCPRemitente(e.target.value)
                          : setCPRemitente("")
                      }
                    />
                  </Grid>
                  <Grid item sm={12} md={6}>
                    <TextField
                      variant="outlined"
                      label="Teléfono"
                      color="primary"
                      className={classes.formItem}
                      value={telefonoRemitente}
                      onChange={(e) =>
                        e
                          ? setTelefonoRemitente(e.target.value)
                          : setTelefonoRemitente("")
                      }
                    />
                  </Grid>
                  <Grid item sm={12} md={6}>
                    <TextField
                      variant="outlined"
                      label="Referencia"
                      color="primary"
                      className={classes.formItem}
                      value={referenciaRemitente}
                      onChange={(e) =>
                        e
                          ? setReferenciaRemitente(e.target.value)
                          : setReferenciaRemitente("")
                      }
                    />
                  </Grid>
                </Grid>
              </div>
            </Paper>
          </Grid>
          <Grid item sm={12} md={6} >
          <Paper className={classes.paper} style={{margin:0}}>
              <Typography
                component="h1"
                variant="h6"
                className={classes.titulo}
              >
                2 - Paquetería:
              </Typography>
              <div className={classes.formCol}>
                <Grid container spacing={3}>
                  
                  <Grid item sm={12}>
                  <Select
                    className={classes.select}
                    options={paqueteriasRecolecciones}
                    placeholder="Paquetería*"
                    value={paqueteria}
                    onChange={setPaqueteriasRecolecciones}
                  />
                  </Grid>
                  <label style={{margin:"0px 15px"}}>Las recolecciones se agendan el siguiente día hábil de su solicitud.</label>
                  <Grid item sm={12} md={12}>
                    <TextField
                      variant="outlined"
                      label="Fecha de recolección"
                      color="primary"
                      className={classes.formItem}
                      value={getNextWork(new Date())}
                      onChange={(e) =>
                        e
                          ? setFechaRecoleccion(e.target.value)
                          : setFechaRecoleccion("")
                      }
                      disabled
                    />
                  </Grid>
                  <Grid item sm={12} md={6}>
                    <TextField
                      variant="outlined"
                      label="Inicio de recolección"
                      color="primary"
                      className={classes.formItem}
                      value={horaInicial}
                      onChange={(e) =>
                        e
                          ? setHoraInicial(e.target.value)
                          : setHoraInicial("")
                      }
                      disabled
                    />
                  </Grid>
                  <Grid item sm={12} md={6}>
                    <TextField
                      variant="outlined"
                      label="Fin de recolección"
                      color="primary"
                      className={classes.formItem}
                      value={horaFinal}
                      onChange={(e) =>
                        e
                          ? setHoraFinal(e.target.value)
                          : setHoraFinal("")
                      }
                      disabled
                    />
                  </Grid>
                </Grid>
              </div>
              <Typography
                component="h1"
                variant="h6"
                className={classes.titulo}
              >
                3 - Paquete:
              </Typography>
              <div className={classes.formCol}>
                <Grid container spacing={3}>
                  <Grid item sm={12} md={6}>
                    <TextField
                      type="number"
                      variant="outlined"
                      label="Cantidad de paquetes"
                      color="primary"
                      className={classes.formItem}
                      value={paquetes}
                      onChange={(e) =>
                        e
                          ? setPaquetes(+e.target.value)
                          : setPaquetes("")
                      }
                    />
                  </Grid>
                  <Grid item sm={12} md={6}>
                    <TextField
                      type="number"
                      variant="outlined"
                      label="Peso total de los paquetes"
                      color="primary"
                      className={classes.formItem}
                      value={peso}
                      onChange={(e) =>
                        e
                          ? setPeso(+e.target.value)
                          : setPeso("")
                      }
                    />
                  </Grid>
                  <Grid item sm={12} md={6}>
                  <Button
                    onClick={handleRecoleccion}
                    className={classes.botonRecolectar}
                    color="primary"
                    variant="contained"
                    disabled={isLoading}
                  >
                    Agendar recolección
                    {isLoading && <CircularProgress color="secondary" />}  
                  </Button>
                  </Grid>
                </Grid>
              </div>
            </Paper>
          </Grid>
          <Snackbar
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
              open={showError}
              autoHideDuration={5000}
              onClose={() => setShowError(false)}
            >
              <SnackbarWrapper
                onClose={() => setShowError(false)}
                variant="error"
                message={errorMessage}
              />
            </Snackbar> 
            {Object.keys(data).length !== 0 && errorRecoleccion==="Generada" && (
              <Modal
                handlerClose={handleModalClose}
                open={showModal}
              />
            )}
        </Grid> 
      :''}
      {currentTable === "recolecciones" && (
        <TableRecolecciones data={data.data} />
      )} 
      </div>);
}
 
export default Recolecciones;